import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            
            <div className="footer-brand-header">
              <h3>Brilha Piscina</h3>
              <a 
                href="https://www.instagram.com/brilha_piscina" 
                target="_blank" 
                rel="noopener noreferrer"
                className="instagram-link"
                aria-label="Instagram Brilha Piscina"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z"></path>
                  <circle cx="17.5" cy="6.5" r="1.5"></circle>
                </svg>
              </a>
            </div>
            <p>
              Especialistas em manutenção de <b>máquinários</b> e tratamento de piscinas. 
              <br></br>
              Qualidade e confiança há mais de <b>21 anos.</b>
            </p>
          </div>

          
          </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <p>CNPJ: 37.294.417/0001-14</p>
            <p>&copy; {currentYear} Brilha Piscina. Todos os direitos reservados.</p>
          </div>
          <div className="footer-credits">
            <p>
              Desenvolvido por{' '}
              <a 
                href="https://www.agenciakagi.com.br" 
                target="_blank" 
                rel="noopener noreferrer"
                className="agency-link"
              >
                Agência Kagi
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
